var e = function e() {
    document.body.style.top = "-".concat(window.scrollY, "px"), document.body.style.position = "fixed", document.body.style.overflow = "hidden", document.body.tabIndex = 1;
  },
  t = function t() {
    var o = document.body.style.top;
    document.body.style.top = "", document.body.style.position = "", document.body.style.overflow = "auto", document.body.removeAttribute("tabindex"), window.scrollTo(0, parseInt(o || "0", 10) * -1);
  };
export { e as disablePageScroll, t as enablePageScroll };